import React from "react";
import nutritionImage from "../assets/images/mariana-medvedeva-usfIE5Yc7PY-unsplash.jpg";
import ContactUs from "./organisms/ContactUs";
import HeadingText from "./atoms/HeadingText";
import ContentText from "./atoms/ContentText";
import ParaText from "./atoms/ParaText";
import useTranslate from "../hooks/useTranslate";

function IndividualNutrition() {
  return (
    <>
      <section className=" bg-white py-12">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row">
          <div className="basis-1/2 mb-4">
            <img
              src={nutritionImage}
              alt="Nutrition"
              className="md:max-w-[90%] max-w-[100%]"
            />
          </div>
          <div className="basis-1/2">
            <HeadingText variant="h2">
              {useTranslate(
                "workwithMnPage.individualNutition.section.heading2",
              )}
            </HeadingText>
            <HeadingText variant="h3">
              {useTranslate(
                "workwithMnPage.individualNutition.section.heading3",
              )}
            </HeadingText>
            <ContentText>
              {useTranslate(
                "workwithMnPage.individualNutition.section.contentText1",
              )}
            </ContentText>
            <ParaText classes="font-bold">
              {useTranslate(
                "workwithMnPage.individualNutition.section.paraTextBold",
              )}
            </ParaText>
            <ContentText>
              {useTranslate(
                "workwithMnPage.individualNutition.section.contentText2",
              )}
            </ContentText>
          </div>
        </div>
      </section>
      <ContactUs />
    </>
  );
}

export default IndividualNutrition;
